import { useState } from "react";
import { motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function BottomExpandablePanel({ children, newZone }) {
  const { t } = useTranslation("common");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`fixed left-0 w-full flex justify-center transition z-[10] pointer-events-none ${
        !isOpen ? "bottom-1" : "bottom-[-20px]"
      }`}
    >
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: isOpen ? "0%" : "100%" }}
        transition={{ type: "spring", stiffness: 150, damping: 20 }}
        className="w-full bg-ui-surface shadow-soft-lg rounded-t-2xl p-4 border border-ui-border pointer-events-auto"
      >
        {isOpen ? (
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center">
              <button
                onClick={() => setIsOpen(false)}
                className="flex items-center text-sm  absolute top-[-36px] gap-2 px-4 py-2 bg-brand text-white rounded-t-md shadow-soft-md hover:bg-brand-hover transition"
              >
                <FiChevronDown size={20} />
                {t("zoneSettings")}
              </button>
            </div>
            <div className="w-full p-1 h-[80vh] overflow-y-auto">
              {children}
            </div>
          </div>
        ) : (
          <>
            {" "}
            <div className="w-full flex justify-center">
              {" "}
              <button
                onClick={() => setIsOpen(true)}
                className={`flex items-center text-sm  absolute top-[-36px] gap-2 px-4 py-2 bg-brand text-white rounded-t-md shadow-soft-md hover:bg-brand-hover transition ${
                  newZone ? "pointer-events-none opacity-50 cursor-default" : ""
                }`}
              >
                <motion.div
                  animate={{ y: [-0.5, 0.5, -0.5] }}
                  transition={{
                    repeat: Infinity,
                    duration: 0.6,
                    ease: "easeInOut",
                  }}
                >
                  <FiChevronUp size={20} />
                </motion.div>
                {t("zoneSettings")}
              </button>
            </div>
            <div className="w-full p-1 h-[80vh] overflow-y-auto">
              {children}
            </div>
          </>
        )}
      </motion.div>
    </div>
  );
}
